import React, {Component} from 'react';

import './ViewAllMetadata.scss';
import * as messageConstants from "../../../shared/messages";
import CertificateParameterItem from "./CertificateParameterItem";

class CertificateDetails extends Component {
  state = {
    showCertificateDetailsSection: false,
  }
  handleShowCertificateDetailsSection = () => {
    this.setState({showCertificateDetailsSection: true});
  }
  handleHideCertificateDetailsSection = () => {
    this.setState({showCertificateDetailsSection: false});
  }

  render() {
    return (
        <div>
          {
            this.props.certificateDetails !== null ?
                (<div>
                  <div className="certificate-entry-title">
                    {
                      this.state.showCertificateDetailsSection ?
                          (<button
                              className="fa fa-minus btn no-border-and-background-btn primary-color"
                              onClick={this.handleHideCertificateDetailsSection}/>)
                          :
                          (<button
                              className="fa fa-plus btn no-border-and-background-btn primary-color"
                              onClick={this.handleShowCertificateDetailsSection}/>)
                    }
                    {this.props.certificateDetails.certificateDetails}
                  </div>
                  <div>
                    {
                      this.state.showCertificateDetailsSection ?
                          (<div className="view-certificate-entry-container">
                            <CertificateParameterItem
                                label={messageConstants.VERSION}
                                value={this.props.certificateDetails.version}/>
                            <CertificateParameterItem
                                label={messageConstants.SERIAL_NUMBER}
                                value={this.props.certificateDetails.serialNumber}/>
                            <CertificateParameterItem
                                label={messageConstants.SIGNATURE_ALGORITHM}
                                value={this.props.certificateDetails.signatureAlgorithm}/>
                            <CertificateParameterItem
                                label={messageConstants.ISSUER}
                                value={this.props.certificateDetails.issuer}/>
                            <div className="certificate-entry-no-value"/>
                            <CertificateParameterItem
                                label={messageConstants.VALID_NOT_BEFORE}
                                value={this.props.certificateDetails.validNotBefore}/>
                            <CertificateParameterItem
                                label={messageConstants.VALID_NOT_AFTER}
                                value={this.props.certificateDetails.validNotAfter}/>
                            <div className="certificate-entry-no-value"/>
                            <CertificateParameterItem
                                label={messageConstants.SUBJECT}
                                value={this.props.certificateDetails.subject}/>
                            <div
                                className="certificate-entry-value">{messageConstants.SUBJECT_PUBLIC_KEY_INFO}</div>
                            <div className="pl-30">
                              <CertificateParameterItem
                                  label={messageConstants.PUBLIC_KEY_ALGORITHM}
                                  value={this.props.certificateDetails.publicKeyAlgorithm}/>
                              <div
                                  className="certificate-entry-value">{messageConstants.PUBLIC_KEY}</div>
                              <div className="pl-30">
                                <CertificateParameterItem
                                    label={messageConstants.PUB}
                                    value={this.props.certificateDetails.publicKey}/>
                              </div>
                            </div>
                            <div className="certificate-entry-no-value"/>
                            <div className="pl-30">
                              <CertificateParameterItem
                                  label={messageConstants.SIGNATURE_ALGORITHM}
                                  value={this.props.certificateDetails.signatureAlgorithm}/>
                              <div
                                  className="pl-30 certificate-entry-value">{this.props.certificateDetails.signature}</div>
                            </div>
                          </div>) : null
                    }
                  </div>
                  <div className="certificate-entry-bottom"/>
                </div>) : null
          }
        </div>
    );
  }
}

export default CertificateDetails;


// WEBPACK FOOTER //
// ./src/components/AddSAML/ViewAllMetadataPopup/CertificateDetails.js